import { MAX_PIVOT_ROWS } from "helpers/ai"

export function isPivotable(key, records = []) {
  return !key.toLowerCase().includes("date")
    && !key.toLowerCase().includes("time")
    && records
    && new Set(records.map(record => record[key])).size <= MAX_PIVOT_ROWS
}
